import React, { memo, useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import TypeWriter from './TypeWriter';
import {
  aigcReplysWritingEnd,
  aigcReplyWritingStop,
  aigcReplyIsBusing,
  aigcGetReplys,
  aigcReplysZanDao,
  aigcShowMessage,
} from '../../../../actions/aigc';
import { logging } from '../../../../actions/log';

const selectIsBusing = createSelector(
  state => state.aigc,
  aigc => aigc.isBusing,
);
const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

export default memo(
  ({
    styles,
    answerIndex,
    answerItem = {},
    answerIndexShow,
    h5IDAll,
    start = () => {},
    showOperate = false,
    reAnswerShow,
    userText,
    reAnswerback = () => {},
  }) => {
    const dispatch = useDispatch();
    const likeNode = useRef(null);
    const dislikeNode = useRef(null);
    const [stopTag, setStopTag] = useState(false);
    const isBusing = useSelector(selectIsBusing);

    useEffect(() => {
      if (isBusing === 4) {
        setStopTag(true);
      }
    }, [isBusing]);

    const handlePauseText = data => {
      dispatch(aigcReplyWritingStop({ h5IDAll, h5ID: answerItem?.h5ID, ...data }));
      dispatch(aigcReplyIsBusing({ isBusing: 4 }));
    };

    const answerback = () => {
      if (!stopTag) {
        dispatch(aigcReplysWritingEnd({ h5IDAll, h5ID: answerItem?.h5ID }));
        dispatch(aigcReplyIsBusing({ isBusing: 5 }));
      }
    };
    const handleEvaluate = opt => {
      let left = '';
      let right = '';
      let param3 = {};
      try {
        param3 = JSON.parse(answerItem?.bizInfo);
      } catch (e) {
        param3 = {};
      }
      if (opt === '1') {
        if (answerItem?.isZan) {
          left = false;
        } else {
          left = true;
          if (answerItem?.isDao) {
            right = false;
          }
        }
        dispatch(
          logging({
            category: 'C',
            action: 'Search_Aigc_Satisfy',
            label: '',
            param2: {
              search_word: userText,
            },
            param3: param3,
          }),
        );
      } else {
        if (answerItem?.isDao) {
          right = false;
        } else {
          right = true;
          if (answerItem?.isZan) {
            left = false;
          }
        }
        dispatch(
          logging({
            category: 'C',
            action: 'Search_Aigc_NoSatisfy',
            label: '',
            param2: {
              search_word: userText,
            },
            param3: param3,
          }),
        );
      }
      dispatch(
        aigcReplysZanDao({
          h5IDAll,
          h5ID: answerItem?.h5ID,
          isZan: left,
          isDao: right,
        }),
      );
    };

    const handleReAnswer = () => {
      let param3 = {};
      try {
        param3 = JSON.parse(answerItem?.bizInfo);
      } catch (e) {
        param3 = {};
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Search_Aigc_Recall',
          label: '',
          param2: {
            search_word: userText,
          },
          param3: param3,
        }),
      );

      dispatch(
        aigcGetReplys({
          isReAnswer: true,
          reAnswer: {
            h5IDAll,
            h5ID: answerItem?.h5ID,
          },
        }),
      );
      reAnswerback();
    };

    return (
      <>
        {answerItem?.writing === 2 && (
          <>
            <TypeWriter
              node={`${
                answerIndexShow ? `<span class=${styles.chat_index}>回答${answerIndex}</span> ` : ``
              }
        <span class="info_title">${answerItem?.commandMsg?.tip}</span>
        ${answerItem?.commandMsg?.appList
          .map(
            (softEl, softIndex) =>
              `<div class="info_soft_item_w" key=${softIndex}>
            <span>
            ${answerItem?.commandMsg?.appList?.length > 1 ? `<span>${softIndex + 1}:</span>` : ``}
            ${softEl?.detailInfo}
            <span/>
          </div>`,
          )
          .join('')}
       
        `}
              answerCallback={answerback}
              startCallback={() => {
                start();
              }}
              controlStop={stopTag}
              stopCallback={data => handlePauseText(data)}
            />
          </>
        )}
        {answerItem?.writing === 3 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className="info_title">{answerItem?.commandMsg?.tip}</span>
            {answerItem?.commandMsg?.appList.map((softEl, softIndex) => (
              <div className="info_soft_item" key={softIndex}>
                <span>
                  {answerItem?.commandMsg?.appList?.length > 1 && (
                    <span>{`${softIndex + 1}:`}</span>
                  )}
                  <span dangerouslySetInnerHTML={{ __html: softEl?.detailInfo }} />
                </span>
              </div>
            ))}
            <div className="info_operate">
              {showOperate && reAnswerShow && answerItem.canFresh && (
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              )}

              <div className="evaluate">
                <div className="icon_left">
                  <i
                    className={`iconfont icon-ai_xihuan ${
                      answerItem?.isZan ? styles.i_active : ''
                    }`}
                    ref={likeNode}
                    onClick={() => (answerItem?.isDao ? () => {} : handleEvaluate('1'))}
                  />
                  <div className="icon_left_desc">喜欢</div>
                </div>
                <div className="icon_right">
                  <i
                    className={`iconfont icon-ai_buxihuan ${
                      answerItem?.isDao ? styles.i_active : ''
                    }`}
                    ref={dislikeNode}
                    onClick={() => (answerItem?.isZan ? () => {} : handleEvaluate('2'))}
                  />
                  <div className="icon_right_desc">不喜欢</div>
                </div>
              </div>
            </div>
          </>
        )}
        {answerItem?.writing === 4 && (
          <>
            {answerIndexShow && <span className={styles.chat_index}>回答{answerIndex}</span>}{' '}
            <span className="info_title">根据您的输入，小乐为您找到以下软件</span>
            {answerItem?.commandMsg?.appList.map((softEl, softIndex) => (
              <div className="info_soft_item" key={softIndex}>
                <span>{softEl?.pauseDesc}</span>
              </div>
            ))}
            <div className="info_operate">
              {showOperate && reAnswerShow && answerItem.canFresh && (
                <div className="re_answer" onClick={handleReAnswer}>
                  <i className="iconfont icon-ai_chongxinhuida" /> 重新回答
                </div>
              )}

              <div className="evaluate">
                <div className="icon_left">
                  <i
                    className={`iconfont icon-ai_xihuan ${
                      answerItem?.isZan ? styles.i_active : ''
                    }`}
                    ref={likeNode}
                    onClick={() => (answerItem?.isDao ? () => {} : handleEvaluate('1'))}
                  />
                  <div className="icon_left_desc">喜欢</div>
                </div>
                <div className="icon_right">
                  <i
                    className={`iconfont icon-ai_buxihuan ${
                      answerItem?.isDao ? styles.i_active : ''
                    }`}
                    ref={dislikeNode}
                    onClick={() => (answerItem?.isZan ? () => {} : handleEvaluate('2'))}
                  />
                  <div className="icon_right_desc">不喜欢</div>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  },
);
